export { default as EntityRefData } from './entityRefData.container';
